var styles = {};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
